import { render, staticRenderFns } from "./_Portfolio.vue?vue&type=template&id=046062b6&scoped=true"
import script from "./_Portfolio.vue?vue&type=script&lang=js"
export * from "./_Portfolio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046062b6",
  null
  
)

export default component.exports